import { shadows } from "../../primitives/shadows";
import type { ShadowTheme } from "../../semantic/shadows";

export const baseShadows: ShadowTheme = {
  none: shadows.none,
  xs: shadows.xs,
  sm: shadows.sm,
  md: shadows.md,
  lg: shadows.lg,
  xl: shadows.xl,
  soft: shadows.soft,
};
